import {Automations} from './Automations';
import {fromString} from "../ToastMessage";

const COLLAPSED_KEY = 'automations:collapsedEvents';

const initializedElements = new WeakSet();

const getCollapsedEvents = () => {
    try {
        return new Set(JSON.parse(localStorage.getItem(COLLAPSED_KEY)) ?? []);
    } catch {
        return new Set();
    }
};

const saveCollapsedEvents = (collapsed) => {
    localStorage.setItem(COLLAPSED_KEY, JSON.stringify([...collapsed]));
};

const collapsibleGroups = () => {
    const workflowList = document.querySelector('.workflow-list');

    const activeSlug = workflowList
        ?.querySelector('li.active')
        ?.closest('.workflow-group[data-event-slug]')
        ?.dataset.eventSlug;

    return [...workflowList?.querySelectorAll('.workflow-group[data-event-slug]') ?? []]
        .filter((group) => group.dataset.eventSlug !== activeSlug);
};

const syncCollapseAllButton = () => {
    const eventSelectorRow = document.querySelector('.event-selector-row');

    if (!eventSelectorRow) {
        return;
    }

    const groups = collapsibleGroups();

    eventSelectorRow.classList.toggle(
        'all-collapsed',
        groups.length > 0 && groups.every((group) => group.classList.contains('collapsed')),
    );
};

const initializeWorkflowList = workflowList => {
    const collapsed  = getCollapsedEvents();
    const activeItem = workflowList.querySelector('li.active');
    const activeGroup = activeItem?.closest('.workflow-group[data-event-slug]');

    if (activeGroup && collapsed.has(activeGroup.dataset.eventSlug)) {
        collapsed.delete(activeGroup.dataset.eventSlug);
        saveCollapsedEvents(collapsed);
    }

    workflowList.querySelectorAll('.workflow-group[data-event-slug]').forEach((group) => {
        if (collapsed.has(group.dataset.eventSlug)) {
            group.classList.add('collapsed');
        }
    });

    syncCollapseAllButton();

    requestAnimationFrame(() => workflowList.classList.add('animate'));

    workflowList.addEventListener('click', async (event) => {
        const collapseToggle = event.target.closest('[data-collapse-toggle]');

        if (collapseToggle) {
            if (event.target.closest('a')) {
                return;
            }

            const group   = collapseToggle.closest('.workflow-group');
            const eventSlug = group.dataset.eventSlug;

            group.classList.toggle('collapsed');

            const collapsed = getCollapsedEvents();

            if (group.classList.contains('collapsed')) {
                collapsed.add(eventSlug);
            } else {
                collapsed.delete(eventSlug);
            }

            saveCollapsedEvents(collapsed);
            syncCollapseAllButton();

            return;
        }

        const wrapper = event.target.closest('.form-toggle-wrap');

        if (!wrapper) {
            return;
        }

        const button = wrapper.querySelector('.form-toggle');

        const listItem = wrapper.closest('li');

        const setActive = (active) => {
            button.classList.toggle('enabled', active);
            listItem.classList.toggle('enabled', active);

            if (listItem.classList.contains('active')) {
                document.querySelector('.workflow-status-label').classList.toggle('disabled', !active);
            }
        };

        const active = !button.classList.contains('enabled');

        setActive(active);

        const form = new FormData();

        form.set('active', +active);

        const response = await fetch(wrapper.dataset.url, {
            method: 'post',
            body: form,
        });

        if (!response.ok) {
            setActive(!active);
            fromString(await response.text());
        }
    });

    workflowList.addEventListener('sortabledrop', async (event) => {
        const listItem = event.target.closest('li');
        const groupList = listItem.closest('ul');

        const url = listItem.dataset.sortUrl;

        const form = new FormData();

        groupList.querySelectorAll('li[data-workflow-id]').forEach((item) => {
            form.append('workflows[]', parseInt(item.dataset.workflowId, 10));
        });

        const response = await fetch(url, {
            method: 'POST',
            body: form,
        });

        if (!response.ok) {
            event.detail.restore();

            fromString(await response.text());
        }
    });
};

const initializeCollapseAllButtons = eventSelectorRow => {
    eventSelectorRow.querySelectorAll('[data-collapse-all]').forEach((button) => {
        button.addEventListener('click', (event) => {
            event.currentTarget._tippy?.hide();

            const groups         = collapsibleGroups();
            const shouldCollapse = groups.some((group) => !group.classList.contains('collapsed'));

            groups.forEach((group) => group.classList.toggle('collapsed', shouldCollapse));

            saveCollapsedEvents(new Set(shouldCollapse ? groups.map((group) => group.dataset.eventSlug) : []));
            syncCollapseAllButton();
        });
    });
};

const initializeWorkflowEditor = container => {
    new Automations(container);
};

const initializeOnce = (root, selector, initialize) => {
    root.querySelectorAll(selector).forEach(element => {
        if (initializedElements.has(element)) {
            return;
        }

        initializedElements.add(element);

        initialize(element);
    });
};

export const initializeWorkflows = root => {
    initializeOnce(root, '.workflow-list', initializeWorkflowList);
    initializeOnce(root, '.event-selector-row', initializeCollapseAllButtons);
    initializeOnce(root, 'div.automations', initializeWorkflowEditor);
};
